export default __webpack_public_path__ + "static/media/Bangles of the Faceless Chaos.236139c4.jpg";